var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-primary"},[(!!_vm.paymentMethod)?[_vm._v(_vm._s(_vm.paymentMethod))]:[_vm._v("Nie wybrano metody płatności")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }